import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Stack, Text, Popover, PopoverItem, Button } from '@hub-la/design-system';
import { Sort } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrderDir } from '../../../domain/enums/order-dir.js';
import { useDiscussion } from '../../providers/discussion.js';

const Count = ({
  total,
  isLoading
}) => {
  const {
    setOrderDir
  } = useDiscussion();
  const {
    t
  } = useTranslation();
  if (isLoading) return jsx(Skeleton, {
    variant: "text",
    width: 130,
    height: 24,
    sx: {
      mb: 4.5
    }
  });
  return jsxs(Stack, Object.assign({
    direction: "row",
    alignItems: "center",
    gap: 3,
    mb: 4.5
  }, {
    children: [jsxs(Text, Object.assign({
      variant: "body1",
      fontWeight: 700
    }, {
      children: [total, " coment\u00E1rios"]
    })), jsx(Popover, Object.assign({
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      items: ({
        close
      }) => jsxs(Stack, {
        children: [jsx(PopoverItem, Object.assign({
          onClick: () => {
            close();
            setOrderDir(OrderDir.DESC);
          }
        }, {
          children: t('orderComments.newest')
        })), jsx(PopoverItem, Object.assign({
          onClick: () => {
            close();
            setOrderDir(OrderDir.ASC);
          }
        }, {
          children: t('orderComments.oldest')
        }))]
      })
    }, {
      children: jsx(Button, Object.assign({
        variant: "text",
        hierarchy: "secondary",
        size: "small",
        iconOnly: true
      }, {
        children: jsx(Sort, {})
      }))
    }))]
  }));
};

export { Count };
